import {
  Button,
  TagInputSelectControl,
  TextInputField,
  IconTrashCan,
  RedRed60,
  Flex
} from '@sequencehq/core-components'
import { ValidationError } from '@sequencehq/utils'

type EventPropertyFieldProps = {
  eventProperty: {
    value: string
    onChange: (value: string) => void
  }
  value: {
    value: string
    onChange: (value: string) => void
  }
  canDelete?: boolean
  onDelete?: () => void
  options: {
    id: string
    value: string
    label: string
  }[]
  validationErrors?: ValidationError[]
}

export const EventPropertyField = ({
  eventProperty,
  value,
  canDelete = false,
  onDelete,
  options,
  validationErrors = []
}: EventPropertyFieldProps) => {
  return (
    <Flex gap={2} alignContent="center" alignItems="center">
      <TagInputSelectControl
        allowCreate
        triggerStyle={{
          width: '220px'
        }}
        placeholder="Select event property"
        value={eventProperty.value}
        onChange={eventProperty.onChange}
        options={options}
      />
      <TextInputField
        label=""
        value={value.value}
        onChange={e => value.onChange(e.target.value)}
        validationErrors={validationErrors}
        styles={{
          wrapper: {
            width: '100%',
            marginBottom: 0
          }
        }}
      />
      {canDelete && (
        <Button
          aria-label="Delete property filter"
          size="32px"
          style={{ flexShrink: '0', color: RedRed60 }}
          icon={<IconTrashCan />}
          onClick={onDelete}
          variant="ghost"
        />
      )}
    </Flex>
  )
}
